import { z } from "zod";

export const RealtimeModelUpgradeSchema = z.object({
  tier: z.enum(["smb", "enterprise"]),
  // Informational only, so a new provider or model doesn't turn a successful upgrade into an error.
  provider: z.string().min(1),
  model: z.string().min(1),
});

export type RealtimeModelUpgrade = z.infer<typeof RealtimeModelUpgradeSchema>;
